import { useQuery } from '@apollo/client/react';
import { Typography } from '@mui/material';
import * as React from 'react';
import {
  Datagrid,
  DateField,
  ListContextProvider,
  TextField,
  useList,
  useRecordContext,
} from 'react-admin';

import {
  AdminGetUserAuthHistoryDocument,
  AdminUserDetailsFragment,
} from '../../../../graphql/types';
import { getGraphQLErrorDetails } from '../../../../utils/getGraphQLErrorDetails';

export const MemberAuthHistoryTab: React.FC = () => {
  const record = useRecordContext<AdminUserDetailsFragment>();
  const { data, error, loading } = useQuery(AdminGetUserAuthHistoryDocument, {
    variables: {
      userId: record!.id, // see skip
    },
    skip: !record?.id,
  });
  const authHistory = data?.user?.authHistory;

  const { errorRequestId, errorPath } = getGraphQLErrorDetails(error);

  const listContext = useList({ data: authHistory?.nodes, isPending: loading });

  return (
    <>
      <Typography variant="h6" fontSize={14}>
        Note: This only includes data for username/password users, not SSO users
      </Typography>
      {error && (
        <>
          <Typography color="error">
            An error occurred while fetching auth history.
          </Typography>

          {errorPath && (
            <Typography color="error" fontSize={12}>
              Path: {errorPath}
            </Typography>
          )}
          {errorRequestId && (
            <Typography color="error" fontSize={12}>
              Request Id: {errorRequestId}
            </Typography>
          )}
        </>
      )}
      {!error && (
        <ListContextProvider value={listContext}>
          <Datagrid bulkActionButtons={false} rowClick={false}>
            <DateField source="eventDate" showTime />
            <TextField source="type" />
            <TextField source="status" />
            <TextField source="challengeResponses" />
          </Datagrid>
        </ListContextProvider>
      )}
    </>
  );
};
